import axios from "axios";
import { url } from "./apiLocation.js";

const stationDataAPI = {
    getAvailableMonthStations: (location_id, date) => {
        return new Promise((resolve, reject) => {
            axios
                .post (
                    `https://${url()}/api/booking/getAvailableMonthStations`,
                    {
                        location_id: location_id,
                        date: date
                    }
                )
                .then(response => {
                    // console.log("RESPONSE DATA: ", response.data);
                    resolve(response.data);
                })
                .catch(error => {
                    // console.log("locationId", location_id);
                    // console.log("date", date);
                    reject(error);
                });
        });
    }
}

export default stationDataAPI;